let language = {
    STORE_PRODUCT_SETTING_PRICE_CONFIG_BY_REVENUE_HEAD_PRICE_STRATEGY:"Price Strategy",
    STORE_PRODUCT_SETTING_PRICE_CONFIG_BY_REVENUE_HEAD_REVENUE:"Revenue",
    STORE_PRODUCT_SETTING_PRICE_CONFIG_BY_REVENUE_FIX:"fix",
    STORE_PRODUCT_SETTING_PRICE_CONFIG_BY_REVENUE_PERCENT:"percent",

};


export { language }